import { getPathnameItem } from "helpers/inventory-filters";
import upperCase from "lodash/upperCase";
import { useRouter } from "next/router";

function useInventoryDescription() {
  const router = useRouter();
  const { slug } = router.query;
  const make = getPathnameItem(slug, "make") ?? "";
  const model = getPathnameItem(slug, "model") ?? "";
  const year = getPathnameItem(slug, "year") ?? "";
  const formattedYear = year ? `${year} ` : "";
  const city = getPathnameItem(slug, "city") ?? "";
  const province = getPathnameItem(slug, "province") ?? "";
  const formattedCar = [make, model].filter(Boolean).join(" ") || "car";
  const finalLocationString =
    city && province ? ` in ${city}, ${upperCase(province)}` : "";
  return `Looking to buy a new or used ${formattedYear}${formattedCar}${finalLocationString}? VINN has a large selection of sedans, coupes, trucks and SUVs for sale.`;
}

export default useInventoryDescription;
